export const GET_SUBSCRIPTION_TRANSACTION_HISTORY = "GET_SUBSCRIPTION_TRANSACTION_HISTORY";
export const CREATE_TRANSACTION_V2 = "CREATE_TRANSACTION_V1";
export const GET_USER_MAPPING_LIST = "GET_USER_MAPPING_LIST";
export const GET_PRODUCT_PLAN_INFO = "GET_PRODUCT_PLAN_INFO";
export const SUBSCRIPTION_PAY = "SUBSCRIPTION_PAY";
export const CLEAN_CREATE_TRANSACTION_DATA = "CLEAN_CREATE_TRANSACTION_DATA";
export const UNSUBSCRIBE_SUBSCRIPTION = "UNSUBSCRIBE_SUBSCRIPTION";
export const GET_PAYMENT_METHODS = "GET_PAYMENT_METHODS";
export const CLEAN_PAYMENT_METHOD_DATA = "CLEAN_PAYMENT_METHOD_DATA";